<template>
    <div v-if="catalogue" class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <div class="section-header">
                    <div class="section-header__title">
                        <h1>Katalog jednotek</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="vertical-container__content">
            <div class="container">
                <catalogue-container v-if="columnDefinitions.length && filterDefinitions.length"/>
            </div>
        </div>
    </div>
</template>
<script>
import CatalogueContainer
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Catalogue/CatalogueContainer';

export default {
    components: {CatalogueContainer},
    computed:   {
        catalogue() {
            return this.$store.getters['projects/project/extension/catalogue/catalogue'];
        },
        columnDefinitions() {
            return this.$store.getters['projects/project/extension/catalogue/columnDefinitions'];
        },
        filterDefinitions() {
            return this.$store.getters['projects/project/extension/catalogue/filterDefinitions'];
        }
    }
}
</script>
